var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 14.5V12.25",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 14.5V10",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 3.25V1",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 5.5V1",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 12.25C2.55109 12.25 2.20164 12.25 1.92597 12.1358C1.55844 11.9836 1.26642 11.6915 1.11418 11.324C1 11.0483 1 10.6989 1 10C1 9.30107 1 8.95165 1.11418 8.67595C1.26642 8.30845 1.55844 8.0164 1.92597 7.86415C2.20164 7.75 2.55109 7.75 3.25 7.75C3.94891 7.75 4.29837 7.75 4.57403 7.86415C4.94157 8.0164 5.23358 8.30845 5.38582 8.67595C5.5 8.95165 5.5 9.30107 5.5 10C5.5 10.6989 5.5 11.0483 5.38582 11.324C5.23358 11.6915 4.94157 11.9836 4.57403 12.1358C4.29837 12.25 3.94891 12.25 3.25 12.25Z",
    stroke: "#6929E2",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 7.75C10.0511 7.75 9.70165 7.75 9.42595 7.63585C9.05845 7.4836 8.7664 7.19155 8.61415 6.82405C8.5 6.54835 8.5 6.19891 8.5 5.5C8.5 4.80109 8.5 4.45164 8.61415 4.17597C8.7664 3.80844 9.05845 3.51642 9.42595 3.36418C9.70165 3.25 10.0511 3.25 10.75 3.25C11.4489 3.25 11.7983 3.25 12.074 3.36418C12.4415 3.51642 12.7336 3.80844 12.8858 4.17597C13 4.45164 13 4.80109 13 5.5C13 6.19891 13 6.54835 12.8858 6.82405C12.7336 7.19155 12.4415 7.4836 12.074 7.63585C11.7983 7.75 11.4489 7.75 10.75 7.75Z",
    stroke: "#6929E2",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterModal);
export default __webpack_public_path__ + "static/media/filter-modal.af64303ae0c60a041706783880de582e.svg";
export { ForwardRef as ReactComponent };